import OBTAutoCompleteChips from './OBTAutoCompleteChips';
export default OBTAutoCompleteChips;